import { PaymentMethodsServerKeys } from "./rapydTypes";

export const CATEGORIES = {
	own: {
		type: "tag",
		value: "own",
	},
	like: {
		type: "tag",
		value: "like",
	},
};

// 440,000/20,000/14,400/10,000/4,000 拥有头像
export const StarLevelMappingOwn = [
	{
		level: 1,
		price: "4,000",
	},
	{
		level: 2,
		price: "10,000",
	},
	{
		level: 3,
		price: "14,400",
	},
	{
		level: 4,
		price: "20,000",
	},
	{
		level: 5,
		price: "440,000",
	},
];

// 110,000/5,000/3,500/2,500/1,000 获得头像
export const StarLevelMappingGetting = [
	{
		level: 1,
		price: "1,000",
	},
	{
		level: 2,
		price: "2,500",
	},
	{
		level: 3,
		price: "3,500",
	},
	{
		level: 4,
		price: "5,000",
	},
	{
		level: 5,
		price: "110,000",
	},
];

export const NetWorthOptions = [
	{ value: "1", label: "0-5000" },
	{ value: "2", label: "5001-20000" },
	{ value: "3", label: "20001-50000" },
	{ value: "4", label: "50001-75000" },
	{ value: "5", label: "75001-100000" },
	{ value: "6", label: "100001-250000" },
	{ value: "7", label: "250001-500000" },
	{ value: "8", label: "500001-1000000" },
	{ value: "9", label: "1000001-2000000" },
	{ value: "10", label: "2000001-5000000" },
	{ value: "11", label: "5000001-10000000" },
	{ value: "12", label: "10000001-25000000" },
	{ value: "13", label: "25000001-30000000" },
	{ value: "14", label: "30000001-50000000" },
	{ value: "15", label: "50000001+" },
];

export const LiquidNetWorthOptions = [
	{ value: "1", label: "0-5000" },
	{ value: "2", label: "5001-20000" },
	{ value: "3", label: "20001-50000" },
	{ value: "4", label: "50001-75000" },
	{ value: "5", label: "75001-100000" },
	{ value: "6", label: "100001-250000" },
	{ value: "7", label: "250001-500000" },
	{ value: "8", label: "500001-1000000" },
	{ value: "9", label: "1000001-5000000" },
	{ value: "10", label: "5000001+" },
];

export const AnualNetIncomeOptions = [
	{ value: "1", label: "0-39999" },
	{ value: "2", label: "40000-45000" },
	{ value: "3", label: "45001-50000" },
	{ value: "4", label: "50001-100000" },
	{ value: "5", label: "100001-150000" },
	{ value: "6", label: "150001-200000" },
	{ value: "7", label: "200001-250000" },
	{ value: "8", label: "250001-500000" },
	{ value: "9", label: "500001-1000000" },
	{ value: "10", label: "1000001+" },
];

export const AccountOpeningPageNumberMoney = {
	1: "1.10",
	2: "1.25",
	3: "1.25",
	4: "1.28",
	5: "1.35",
	6: "1.60",
	7: "1.62",
	8: "1.80",
	9: "1.81",
	10: "2.0",
	11: "2.0",
};
export type PageNumberMoneyKeys = keyof typeof AccountOpeningPageNumberMoney;
/**
 *  rockflow investment 服务号
 */

// export const WXConfigs = {
//   appId: "wx7afc837a81c46a22", // 微信公众号唯一标识
//   appSecret: "fcd7f4deaaa66bb24b471ab7dfac7771", // 微信公众号密钥
//   token: "rf_e4393c", // 公众号token 接口验证使用
// };

/**
 * RockFlow Unnivisal 公众号
 */
export const WXConfigs = {
	appId: "wxbeead06fa314d7e5", // 微信公众号唯一标识
	appSecret: "e234a15f7fcaba50416ecba3f537b6c6", // 微信公众号密钥
	token: "rf_e4393c", // 公众号token 接口验证使用
};

// 存入方式排序规则
export const paymentMethodSortRules = {
	cardBeforeWireTransferRule: [
		PaymentMethodsServerKeys.CARD,
		PaymentMethodsServerKeys.HK_WIRE_TRANSFER,
		PaymentMethodsServerKeys.WIRE_TRANSFER,
		PaymentMethodsServerKeys.BANK,
		PaymentMethodsServerKeys.E_WALLET,
	],
	hkWireTransferBeforeWireTransferRule: [
		PaymentMethodsServerKeys.HK_WIRE_TRANSFER,
		PaymentMethodsServerKeys.WIRE_TRANSFER,
		PaymentMethodsServerKeys.CARD,
		PaymentMethodsServerKeys.BANK,
		PaymentMethodsServerKeys.E_WALLET,
	],
	sgdFirstOther: [
		PaymentMethodsServerKeys.SG_WIRE_TRANSFER,
		PaymentMethodsServerKeys.WIRE_TRANSFER,
		PaymentMethodsServerKeys.HK_WIRE_TRANSFER,
		PaymentMethodsServerKeys.CARD,
		PaymentMethodsServerKeys.BANK,
		PaymentMethodsServerKeys.E_WALLET,
	],
	hkWireTransferBeforeCardRule: [
		PaymentMethodsServerKeys.HK_WIRE_TRANSFER,
		PaymentMethodsServerKeys.CARD,
		PaymentMethodsServerKeys.WIRE_TRANSFER,
		PaymentMethodsServerKeys.BANK,
		PaymentMethodsServerKeys.E_WALLET,
	],
	wireTransferBeforeCardRule: [
		PaymentMethodsServerKeys.WIRE_TRANSFER,
		PaymentMethodsServerKeys.HK_WIRE_TRANSFER,
		PaymentMethodsServerKeys.CARD,
		PaymentMethodsServerKeys.BANK,
		PaymentMethodsServerKeys.E_WALLET,
	],
	bankBeforeEWallet: [
		PaymentMethodsServerKeys.BANK,
		PaymentMethodsServerKeys.E_WALLET,
		PaymentMethodsServerKeys.CARD,
		PaymentMethodsServerKeys.WIRE_TRANSFER,
	],
	bankBeforeCard: [
		PaymentMethodsServerKeys.BANK,
		PaymentMethodsServerKeys.CARD,
		PaymentMethodsServerKeys.E_WALLET,
		PaymentMethodsServerKeys.WIRE_TRANSFER,
	],
	hkWireTransferBeforeWireTransfer: [
		PaymentMethodsServerKeys.HK_WIRE_TRANSFER,
		PaymentMethodsServerKeys.WIRE_TRANSFER,
		PaymentMethodsServerKeys.CARD,
		PaymentMethodsServerKeys.BANK,
		PaymentMethodsServerKeys.E_WALLET,
	],
};
